import { render, staticRenderFns } from "./PurchaseWrapper.vue?vue&type=template&id=1ffd8c21&"
import script from "./PurchaseWrapper.vue?vue&type=script&lang=ts&"
export * from "./PurchaseWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports